import React from "react";
import { Search } from "react-feather";
import { ViewModeToggle } from "../ViewModeToggle";
import {
  ToolbarRow,
  Title,
  SearchField,
  SearchIcon,
  SearchInputEl,
} from "./MarketplaceToolbar.styles";
import type { MarketplaceToolbarProps } from "./MarketplaceToolbar.types";

export const MarketplaceToolbar: React.FC<MarketplaceToolbarProps> = ({
  title,
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search connectors",
  viewMode,
  onViewModeChange,
  size = "md",
  searchWidth = "240px",
  className,
}) => (
  <ToolbarRow className={className}>
    <Title>{title}</Title>
    <SearchField $width={searchWidth}>
      <SearchIcon aria-hidden>
        <Search size={20} />
      </SearchIcon>
      <SearchInputEl
        type="search"
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={searchPlaceholder}
        aria-label="Search connectors"
      />
    </SearchField>
    <ViewModeToggle value={viewMode} onChange={onViewModeChange} size={size} />
  </ToolbarRow>
);

export default MarketplaceToolbar;
